// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"b94c4671","12":"9dc549c9","243":"f150e8af","266":"a4c4c41e","289":"4372758f","325":"ee677f1e","453":"858f03c9","848":"2f54a18a"}[chunkId] + ".chunk.js";
};